import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { ContainerScroll } from "@/components/ui/container-scroll-animation";
import { SoundFamiliar } from "@/components/SoundFamiliar";
import { CastleOnSand } from "@/components/CastleOnSand";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { Comparison } from "@/components/Comparison";
import { SocialProof } from "@/components/SocialProof";
import { ROIAnchor } from "@/components/ROIAnchor";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { SideNav } from "@/components/SideNav";
import { SEO } from "@/components/SEO";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "FuzionLabs",
  url: "https://fuzionlabs.org",
  logo: "https://fuzionlabs.org/logo.png",
  description:
    "FuzionLabs builds lead generation and pipeline automation systems exclusively for immigration law firms.",
  sameAs: ["https://www.linkedin.com/company/fuzionlabs/"],
  contactPoint: {
    "@type": "ContactPoint",
    email: "karstenbates@fuzionlabs.org",
    contactType: "customer service",
  },
};

const professionalServiceSchema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "FuzionLabs",
  url: "https://fuzionlabs.org",
  description: "Lead generation and pipeline automation for immigration law firms.",
  serviceType: ["Lead Generation", "Pipeline Automation", "CRM Setup", "Paid Advertising"],
  areaServed: "United States",
  priceRange: "$$$",
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "How do immigration law firms get more clients?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Immigration law firms generate consistent clients through a combination of paid advertising on Meta or Google, automated follow-up systems, CRM pipelines, and fast lead response times. Firms that respond to inquiries within 5 minutes convert significantly more leads than those that wait.",
      },
    },
    {
      "@type": "Question",
      name: "What is a lead generation system for immigration law firms?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "A lead generation system for immigration law firms includes paid ad campaigns targeting potential clients, a CRM to track and manage leads, automated email and SMS follow-up sequences, and appointment reminders — all working together to turn inquiries into retained clients.",
      },
    },
    {
      "@type": "Question",
      name: "How much does it cost to work with FuzionLabs?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "FuzionLabs offers two core packages. The CRM and Systems Setup starts at $2,500 per month. The Full Pipeline System, which includes one paid ad platform, starts at $3,500 per month. Enterprise pricing is custom based on firm size and needs.",
      },
    },
    {
      "@type": "Question",
      name: "How long does it take to see results from immigration law firm marketing?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Most immigration law firms running paid ads through FuzionLabs see leads within the first two weeks of campaign launch. Conversion rates improve over the following 30 to 60 days as the system is optimized.",
      },
    },
    {
      "@type": "Question",
      name: "What makes FuzionLabs different from other marketing agencies?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "FuzionLabs works exclusively with immigration law firms. Every system, ad campaign, and automation is built for the specific needs of immigration practices — including H-1B, green card, DACA, and family-based immigration case types.",
      },
    },
  ],
};

const Index = () => {
  return (
    <div className="relative w-full min-h-screen">
      <SEO
        title="FuzionLabs | Immigration Law Firm Lead Generation"
        description="FuzionLabs builds lead generation and pipeline automation systems built exclusively for immigration law firms. Consistent clients. Predictable growth."
        canonical="https://fuzionlabs.org/"
        ogDescription="Pipeline systems and lead generation built exclusively for immigration law firms."
        jsonLd={[organizationSchema, professionalServiceSchema, faqSchema]}
      />
      <Navbar />
      <SideNav />
      <main>
        <h1 className="sr-only">
          Lead Generation and Pipeline Automation for Immigration Law Firms
        </h1>
        <div id="hero">
          <ContainerScroll titleComponent={<HeroSection />}>
            <SoundFamiliar />
          </ContainerScroll>
        </div>
        <CastleOnSand />
        <Services />
        <ROIAnchor />
        <Process />
        <Comparison />
        <SocialProof />
        <FinalCTA />
        <div id="blog-section" />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
